import { type SyntheticEvent, useCallback, useEffect, useState } from 'react';
import { type StaticImport } from 'next/dist/shared/lib/get-img-props';

export const useHandleImageError = (
  src: string | StaticImport,
  fallback: string,
  onError?: (error: SyntheticEvent<HTMLImageElement, Event>) => void,
) => {
  const [isError, setIsError] = useState(false);

  const handleImageError = useCallback(
    (error: SyntheticEvent<HTMLImageElement, Event>) => {
      if (error.currentTarget.src === fallback) return;
      setIsError(true);
      onError?.(error);
    },
    [fallback, onError, src],
  );

  useEffect(() => {
    // Reset error state when src changes
    setIsError(false);
  }, [src]);

  return { isError, handleImageError, setIsError };
};
